// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/frontend/js/" + chunkId + "." + "e63d97e6" + ".chunk.js";
};